module.exports = __webpack_public_path__ + "static/media/5.c408a356.png";